import classes from './PublicSectors.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const PublicSectors = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = t('publicSectors.title')
    const description = t('publicSectors.text', {returnObjects: true})

    const blackBlocks = t('publicSectors.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('publicSectors.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('publicSectors.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('publicSectors.benefitBlocks', {returnObjects: true})

    const stories = t('publicSectors.stories', {returnObjects: true})


    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('publicSectors.Faq.left', {returnObjects: true}),
        right: t('publicSectors.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    Public Sector & Utilities IT Solutions | Enhancing Public Services – Goteco
                </title>
                <meta
                    name="description"
                    content="Transform public services with our IT solutions, including ERP systems, smart grids, and citizen engagement platforms, designed for the public sector and utilities."
                />
                <link rel="canonical" href="https://go-te.co/industries/public-sectors" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={700}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('publicSectors.blackBlocksTitle')}</h3>
                        <p>{t('publicSectors.blackBlocksText')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('publicSectors.challengesBlocksTitle')}</h2>
                        <p>{t('publicSectors.challengesBlocksText')}</p>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('publicSectors.solutionsBlocksTitle')}</h2>
                        <p>{t('publicSectors.solutionsBlocksText')}</p>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('publicSectors.benefitBlocksTitle')}</h2>
                        <p>{t('publicSectors.benefitBlocksText')}</p>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('publicSectors.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard 
                        title={t('publicSectors.formCard.title')}
                        message={t('publicSectors.formCard.message')}
                        buttonText={t('publicSectors.formCard.buttonText')}
                        labels={t('publicSectors.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
                </section>

                <section className="section--light-gray" id="nav-dark">
                    <FrequentlyAskedQuestions title={t('publicSectors.Faq.title')} questions={questions}/>
                </section>
            </main>
        </>

    );
};

export default PublicSectors;
